export default __webpack_public_path__ + "static/media/4.cd32bf99.png";